function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  fontFamily: "sans-serif",
  fontSize: 10
}, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 49,
  id: "svg_1",
  stroke: "#000",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 42,
  y: 12,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":00"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 62.5,
  y: 18.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":05"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 77.5,
  y: 34.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":10"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 83,
  y: 55,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":15"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 77.5,
  y: 75.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":20"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 62.5,
  y: 90.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":25"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 42,
  y: 96,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":30"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 21.5,
  y: 90.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":35"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 6.5,
  y: 75.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":40"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 1,
  y: 55,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":45"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 6.5,
  y: 34.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":50"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 21.5,
  y: 18.5,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, ":55"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  fontFamily: "sans-serif",
  fontSize: 10
}, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 31,
  id: "svg_2",
  stroke: "#000",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 44.3,
  y: 31,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "12"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 58,
  y: 34.2,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "1"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 66.8,
  y: 43,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "2"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 70,
  y: 55,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "3"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 66.8,
  y: 67,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "4"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 58,
  y: 75.8,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "5"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 47,
  y: 79,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "6"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 34,
  y: 75.8,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "7"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 25.2,
  y: 67,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "8"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 22,
  y: 55,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "9"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 24.3,
  y: 43,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "10"), /*#__PURE__*/React.createElement("text", {
  xmlSpace: "preserve",
  textAnchor: "start",
  id: "svg_2",
  x: 33,
  y: 34.1,
  strokeWidth: 0,
  stroke: "#000",
  fill: "#000000"
}, "11"));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "HoursHand",
  transform: "translate(50,50) rotate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "hhand",
  d: "M -2,2 L 0,-18 L 2,2  z",
  stroke: "#a00",
  strokeOpacity: 0.75,
  fillOpacity: 0
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "HoursKnob",
  transform: "translate(50,50) rotate(0)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "hhand-knob",
  cx: 0,
  cy: -23,
  r: 8,
  stroke: "#000",
  strokeOpacity: 0.75,
  fillOpacity: 0
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Minutes",
  transform: "translate(50,50) rotate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "hhand",
  d: "M -2,2 L 0,-34 L 2,2  z",
  stroke: "#a00",
  strokeOpacity: 0.75,
  fillOpacity: 0
}), /*#__PURE__*/React.createElement("circle", {
  id: "mhand-knob",
  cx: 0,
  cy: -40,
  r: 8,
  stroke: "#000",
  strokeOpacity: 0.75,
  fillOpacity: 0
}));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.3fb85e95.svg";
export { ForwardRef as ReactComponent };